
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Categoria } from '@/__env/lib/Web/Categorias';
    import item from './categorias-listado-item.vue';
    import agregar from './categorias-agregar.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            agregar,
            item,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Filtrados() { return this.Controlador.Filtrados; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }

        public async Abrir( catego: Categoria )
        {
            if ( this.Controlador.Seleccionado )
                this.Controlador.Historial.push( this.Controlador.Seleccionado );

            this.Controlador.Seleccionado = catego;
            this.Buscador.Filtros.Padre = catego.Id;
            this.Filtrados.clear();
            await this.Buscador.Buscar();

        }

        public async Actualizar( catego: Categoria )
        {
            if ( catego.DescripcionNueva && catego.DescripcionNueva.length >= 3 && catego.DescripcionNueva != catego.Descripcion )
            {
                catego.Descripcion = catego.DescripcionNueva;


                if ( await catego.save() )
                {
                    Utiles.Notificaciones.Completado( 'Actualizada!' );
                    catego.DescripcionNueva = catego.Descripcion;
                }
                else
                {
                    Utiles.Notificaciones.Error( 'Error al guardar' );
                }



            }
        }

    }
